import "./OurProducts.module.css";
import Header from "@/reusable_sections/Header";
import DiagnosticEquipmentGrid from "./sections/DiagnosticEquipmentGrid";
import Footer from "@/reusable_sections/Footer";
export default function OurProductsPage() {
  return <div>
      <Header />
      <DiagnosticEquipmentGrid />
      <Footer />
    </div>;
}